import { QdzElement, define } from '@qdz/element';

// Sticky "on scroll up" hides the header group while scrolling down and shows it again on the way up.
// A transparent header turns solid once the page scrolls. A sticky header publishes its visible height as
// --qdz-sticky-header so sticky columns below it stay clear of it.
export class QdzHeader extends QdzElement {
  #last = 0;
  #frame = 0;

  mount() {
    this.#last = window.scrollY;
    const group = this.closest('.qdz-header-group') ?? this;
    if (this.classList.contains('qdz-header--sticky')) {
      const observer = new ResizeObserver(() => this.#publish(group));
      observer.observe(group);
      this.signal?.addEventListener('abort', () => {
        observer.disconnect();
        document.documentElement.style.removeProperty('--qdz-sticky-header');
      });
    }
    this.#update();
    this.listen(window, 'scroll', () => {
      cancelAnimationFrame(this.#frame);
      this.#frame = requestAnimationFrame(() => this.#update());
    }, { passive: true });
    this.listen(this, 'focusin', () => this.removeAttribute('data-hidden'));
  }

  unmount() {
    cancelAnimationFrame(this.#frame);
  }

  #update() {
    const y = Math.max(window.scrollY, 0);
    this.toggleAttribute('data-scrolled', y > 0);
    if (this.classList.contains('qdz-header--sticky-scroll_up')) {
      const open = this.querySelector('details[open], [aria-expanded="true"]');
      const down = y > this.#last && y > this.offsetHeight * 2;
      this.toggleAttribute('data-hidden', down && !open);
      this.#publish(this.closest('.qdz-header-group') ?? this);
    }
    this.#last = y;
  }

  #publish(group) {
    const height = this.hasAttribute('data-hidden') ? 0 : Math.round(group.getBoundingClientRect().height);
    document.documentElement.style.setProperty('--qdz-sticky-header', `${height}px`);
  }
}

define('qdz-header', QdzHeader);
